import React from 'react';
import { Button, Label } from 'govuk-react-jsx';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getPMCData } from '../../features/pmc/pmcJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';

const PmcConfirmVAT = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'pmcClientReg.PmcConfirmVAT.s8',
    "Confirm your client's company VAT details - OZEV Electric Vehicle Chargepoint Grant - GOV.UK"
  );
  const history = useHistory();
  const companyDataRedux = useSelector(getPMCData);

  const redirectCheckAnswers = () => {
    history.push('/pmcClientReg/check-your-answers');
  };

  const handleBtnClick = () => {
    redirectCheckAnswers();
  };

  const pageModel = (
    <>
      <div className="govuk-form-group">
        <Label
          className="govuk-label--xl govuk-!-padding-bottom-7"
          isPageHeading
        >
          {copyProvider.getCopy(
            'pmcClientReg.PmcConfirmVAT.s1',
            'Confirm the company details'
          )}
        </Label>
        <Label className="govuk-label--s">
          {copyProvider.getCopy(
            'pmcClientReg.PmcConfirmVAT.s2',
            'UK VAT registration number'
          )}
        </Label>
        <p className="govuk-body govuk-!-font-size-19">
          {companyDataRedux && companyDataRedux.vatRegNumber}
        </p>
        <Label className="govuk-label--s">
          {copyProvider.getCopy(
            'pmcClientReg.PmcConfirmVAT.s3',
            'Company name'
          )}
        </Label>
        <p className="govuk-body govuk-!-font-size-19">
          {companyDataRedux && companyDataRedux.businessName}
        </p>
        <Label className="govuk-label--s">
          {copyProvider.getCopy(
            'pmcClientReg.PmcConfirmVAT.s4',
            'Registered company address'
          )}
        </Label>
        {companyDataRedux && (
          <div className="govuk-body govuk-!-font-size-19 govuk-!-margin-bottom-5">
            <section>
              {companyDataRedux.businessAddressLine1 &&
                `${companyDataRedux.businessAddressLine1},`}
            </section>
            <section>
              {companyDataRedux.businessAddressLine2 &&
                `${companyDataRedux.businessAddressLine2},`}
            </section>
            <section>
              {companyDataRedux.businessAddressCity &&
                `${companyDataRedux.businessAddressCity},`}
            </section>
            <section>
              {companyDataRedux.businessAddressCounty &&
                `${companyDataRedux.businessAddressCounty},`}
            </section>
            <section>
              {companyDataRedux.businessAddressPostcode &&
                companyDataRedux.businessAddressPostcode}
              {companyDataRedux.businessAddressCountry && ','}
            </section>
            <section>
              {companyDataRedux.businessAddressCountry &&
                companyDataRedux.businessAddressCountry}
            </section>
          </div>
        )}
        <div className="govuk-body govuk-!-font-size-19 govuk-!-margin-bottom-5">
          <section>
            {copyProvider.getCopy(
              'pmcClientReg.PmcConfirmVAT.s7',
              "Your client's company address may be different from the registered company address. If this is the case you may still proceed. We will not use this address to send any letters."
            )}
          </section>
        </div>
        <Link
          className="govuk-link govuk-body govuk-!-font-size-19"
          to="/pmcClientReg/company-VAT-number"
        >
          {copyProvider.getCopy(
            'pmcClientReg.PmcConfirmVAT.s5',
            'This is not my business'
          )}
        </Link>
      </div>
      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy(
          'pmcClientReg.PmcConfirmVAT.s6',
          'Confirm and continue'
        )}
      </Button>
    </>
  );
  return pageModel;
};

export default PmcConfirmVAT;
